import React from 'react';
import { Stack, Text, Breakpoint } from '@moda/om';
import { ShippingMethod } from '../../../hooks/useCart/cart.rest';
import { EditableSection } from '../../EditableSection';
import { ShippingMethodPreviewCharges } from './ShippingMethodPreviewCharges';

import './ShippingMethodPreview.scss';

interface Props {
  option: ShippingMethod | undefined;
  onChange?: () => void;
}

export const ShippingMethodPreview: React.FC<Props> = ({ option, onChange }) => (
  <EditableSection location="shipping-method-preview" onChange={onChange}>
    <div className="ShippingMethodPreview">
      <Stack space={1}>
        <Text className="ShippingMethodPreview__shipping-name">{option?.displayName}</Text>
        <Text className="ShippingMethodPreview__transit-time">{option?.transitTime}</Text>
        <Breakpoint lt="sm">
          <ShippingMethodPreviewCharges option={option} />
        </Breakpoint>
      </Stack>

      <Stack space={1}>
        <Text className="ShippingMethodPreview__delivery-label">Est. Delivery</Text>
        <Text className="ShippingMethodPreview__delivery-time" treatment="bold1">
          {option?.arrivalDate}
        </Text>
      </Stack>

      <Breakpoint gt="sm">
        <ShippingMethodPreviewCharges option={option} />
      </Breakpoint>
    </div>
  </EditableSection>
);
